import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AnimatedRoutes from '../../global/component/organism/AnimatedRoute/AnimatedRoute.tsx';
import ChangePassword from '../Login/ChangePassword/ChangePassword.tsx';
import AdminDashboardShell from './AdminDashboardShell.tsx';
import HcfForm from './Form/HcfForm.tsx';
import HcpForm from './Form/HcpForm.tsx';
import JournalForm from './Form/JournalForm.tsx';
import SurveyForm from './Form/SurveyForm.tsx';
import WrappedTestKitFormTable from './Form/TestKitForm.tsx';
import BillingManagementPage from './Page/BillingManagementPage.tsx';
import WrappedEmailProblemsTable from './Table/EmailProblemsTable.tsx';
import WrappedHcfTable from './Table/HcfTable.tsx';
import WrappedHcpTable from './Table/HcpTable.tsx';
import WrappedJournalTable from './Table/JournalTable.tsx';
import WrappedSurveyTable from './Table/SurveyTable.tsx';
import WrappedTestKitTableTable from './Table/TestKitTable.tsx';
import { OpioidConversionVersionsTable } from './Table/OpioidConversionVersionsTable.tsx';
import OpioidConversionVersionForm from './Form/OpioidConversionVersionForm.tsx';
import { SystemAuditLogTable } from './Table/SystemAuditLogTable.tsx';
import { DrugDosagesTable } from './Table/DrugDosagesTable.tsx';
import WrappedAlertRuleTable from './Table/AlertRuleTable.tsx';
import AlertRuleForm from './Form/Alert/AlertRuleForm.tsx';
import RoleFeatureManagement from './Form/RoleFeatureManagement.tsx';
import { TherapeuticIndicationResourcesTable } from './Table/TherapeuticIndicationResourcesTable.tsx';
import WrappedScenarioTable from './Table/ScenarioTable.tsx';
import ScenarioForm from './Form/ScenarioForm.tsx';
import CarePlanTemplatesPage from './Page/CarePlanTemplatesPage.tsx';
import HcpSwitchoverPage from './Page/HcpSwitchoverPage.tsx';

const AdminDashboardRoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminDashboardShell />}>
        <Route index element={<Navigate to="hcp" replace />} />
        <Route path="changePassword" element={<ChangePassword />} />
        <Route element={<AnimatedRoutes />}>
          <Route index element={<WrappedHcpTable />} />
          <Route path="hcp" element={<WrappedHcpTable />} />
          <Route path="hcp/:id" element={<HcpForm />} />
          <Route path="hcf" element={<WrappedHcfTable />} />
          <Route path="hcf/:id" element={<HcfForm />} />
          <Route path="survey" element={<WrappedSurveyTable />} />
          <Route path="survey/:id" element={<SurveyForm />} />
          <Route path="journal" element={<WrappedJournalTable />} />
          <Route path="journal/:id" element={<JournalForm />} />
          <Route path="testKit" element={<WrappedTestKitTableTable />} />
          <Route path="testKit/:id" element={<WrappedTestKitFormTable />} />
          <Route path="emailProblems" element={<WrappedEmailProblemsTable />} />
          <Route
            path="billing-management"
            element={<BillingManagementPage />}
          />
          <Route
            path="conversion-versions"
            element={<OpioidConversionVersionsTable />}
          />
          <Route
            path="conversion-versions/:id"
            element={<OpioidConversionVersionForm />}
          />
          <Route
            path="dosage-forms"
            element={<DrugDosagesTable />}
          />
          <Route path="alert-rules" element={<WrappedAlertRuleTable />} />
          <Route path="alert-rules/:id" element={<AlertRuleForm />} />
          <Route path="feature-management" element={<RoleFeatureManagement />} />
          <Route path="therapeutic-indication-resources" element={<TherapeuticIndicationResourcesTable />} />
          <Route path="audit-logs" element={<SystemAuditLogTable />} />
          <Route path="scenarios" element={<WrappedScenarioTable />} />
          <Route path="scenarios/:id" element={<ScenarioForm />} />
          <Route path="care-plans" element={<CarePlanTemplatesPage />} />
          <Route path="switchover" element={<HcpSwitchoverPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/hcp" />} />
      </Route>
    </Routes>
  );
};

export default AdminDashboardRoute;
